import { render, staticRenderFns } from "./GasbotFaqCard.vue?vue&type=template&id=68607ceb&scoped=true"
import script from "./GasbotFaqCard.vue?vue&type=script&lang=ts"
export * from "./GasbotFaqCard.vue?vue&type=script&lang=ts"
import style0 from "./GasbotFaqCard.vue?vue&type=style&index=0&id=68607ceb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68607ceb",
  null
  
)

export default component.exports